import React from 'react';

import { useHashRef } from '../Hooks/useHashRef';

export const withHash = ({ Component }: { Component: any }) =>
  React.memo((props: any) => {
    const ref = useHashRef();

    return (
      <div ref={ref}>
        <Component {...props} />
      </div>
    );
  });
